import IFeatureFlagService from "./IFeatureFlagService";
import {IHttpClient} from "../IHttpClient";
import {FeatureFlagModel} from "../../apiModels/FeatureFlag/FeatureFlagModel";

export class FeatureFlagService implements IFeatureFlagService {
    private readonly httpClient: IHttpClient;
    
    constructor(httpClient: IHttpClient) {
        this.httpClient = httpClient;
    }
    
    getFeatureFlags(): Promise<FeatureFlagModel> {
        return new Promise((resolve, reject) => {
            this.httpClient.get('v1/featureflag')
                .then((response: { data: FeatureFlagModel; }) => {
                    resolve(response.data);
                })
                .catch((err: any) => {
                    reject(err);
                })
        })
    }
}